var map = {
	"./images/parachute.png": 1878
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1877;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners ^.*\/parachute\.png$
// module id = 1877
// module chunks = 146